/*
 * Module for the widget host control
*/

rs.module("core/ui/controls/widgets/widgethost",

    ["common/perfect-scrollbar", "controls/help/helphost"],

    function (perfectScrollbar, helpHost) {

        //
        // Initialize the widget host
        //
        function initialize(jsSelectors, backendUrls, pageType) {

            // layout picker elements
            var layoutPickerToggle = $.js(jsSelectors.layoutPickerToggle, { required: false });
            var layoutPickerDropDown = $.js(jsSelectors.layoutPickerDropDown, { required: false });
            var layoutItems = layoutPickerDropDown.js(jsSelectors.layoutItem, { required: false, multiple: true });

            // Show drop down when layout picker gains focus
            layoutPickerToggle.focus(function () {

                // set the max height of the drop down to a third of the height of the window
                layoutPickerDropDown.css("max-height", `${$(window).height() / 3}px`);
                layoutPickerDropDown.show();
            });

            // Hide drop down when layout picker loses focus
            layoutPickerToggle.blur(function () { layoutPickerDropDown.hide(); });

            // Since we are closing the drop down on blur, clicking an item closes the menu
            // However, this prevents the click event of the item from firing
            // To fix this we stop the menu from closing on the mouse down event of clicking an item
            // We subsequently close the drop down inside the click event of the item
            layoutItems.mousedown(event, function () { event.preventDefault(); });

            // Hide drop down when window is resized
            $(window).resize(_.debounce(function () { layoutPickerToggle.blur(); }, 500, {
                'leading': true,
                'trailing': false
            }));

            // Initiate perfect scroll bar for the drop down
            perfectScrollbar.createInstance(layoutPickerDropDown, { suppressScrollX: true });

            // Load the new layout when a layout is selected in the layout picker
            layoutItems.click(function () {

                // close the drop down
                layoutPickerToggle.blur();

                layoutPickerToggle.js(jsSelectors.currentLayoutText).html(`Layout - ${$(this).html()}`)

                $.get(
                    backendUrls.loadLayout,
                    {
                        pageType: pageType,
                        layoutType: $(this).data("layouttype")
                    }

                ).done(function (results) {

                    $.js(jsSelectors.widgetsContainer).html(results);
                });
            });
        }

        //
        // Initialize a widget's frame
        //
        function initializeWidgetFrame(jsSelectors, backendUrls, widgetHostKey, position, availableWidgets) {

            // widget picker elements
            var widgetFrame = $.js(jsSelectors.widgetFrame);
            var widgetPickerToggle = $.js(jsSelectors.widgetPickerToggle, { required: false });
            var widgetPickerDropdown = $.js(jsSelectors.widgetPickerDropdown, { required: false });
            var widgetItem = widgetPickerDropdown.js(jsSelectors.widgetItem, { required: false, multiple: true });

            // Build "dictionary" mappping helpt text to widget ids
            var toolTips = {};
            availableWidgets.forEach(function (item) { toolTips[item.widgetId] = item.helpText; });

            // Show drop down when widget picker gains focus
            widgetPickerToggle.focus(function () {

                // set the max height of the drop down to the height of the widget
                widgetPickerDropdown.css("max-height", `${widgetFrame.height() - 40}px`);
                widgetPickerDropdown.show();
            });

            // Since we are closing the drop down on blur, clicking an item closes the menu
            // However, this prevents the click event of the item from firing
            // To fix this we stop the menu from closing on the mouse down event of clicking an item
            // We subsequently close the drop down inside the click event of the item
            widgetItem.mousedown(event, function () { event.preventDefault(); });

            // Hide drop down when widget picker loses focus
            widgetPickerToggle.blur(function () { widgetPickerDropdown.hide(); });

            // Hide drop down when window is resized
            $(window).resize(_.debounce(function () { widgetPickerToggle.blur(); }, 500, {
                'leading': true,
                'trailing': false
            }));

            // Initiate perfect scroll bar for the drop down
            perfectScrollbar.createInstance(widgetPickerDropdown, { suppressScrollX: true });

            // Load the new widget when a widget is selected in one of the widget pickers
            widgetItem.click(function () {

                // close the drop down
                widgetPickerToggle.blur();

                var newCurrentWidgetText = $(this).text().trim() == "None" ? "Select a widget" : $(this).text();
                widgetPickerToggle.js(jsSelectors.currentWidgetText).html(newCurrentWidgetText);

                var toolTip = widgetFrame.js(jsSelectors.toolTip);
                var helpText = toolTips[$(this).data("widgetid")];

                // if the widget has help text associated with it, show and update the tool tip
                if (helpText) {
                    toolTip.show();
                    helpHost.updateHelpText(toolTip, helpText);
                }
                else {
                    toolTip.hide();
                }

                // immediately clear out the old widget
                $.js(jsSelectors.widgetHolder).empty();

                $.get(
                    backendUrls.loadWidget,
                    {
                        widgetId: $(this).data("widgetid"),
                        widgetHostKey: widgetHostKey,
                        position: position
                    }

                ).done(function (results) {
                    
                    $.js(jsSelectors.widgetHolder).html(results);

                });
            });
        }

        //
        // Initialize an individual widget
        //
        function initializeWidget(jsSelector, backendUrl, instanceId, widgetId) {

            // As soon as a widget is rendered we want to kick off a backend call to check if the widget is done loading.
            $.get(
                backendUrl,
                {
                    instanceId: instanceId,
                    widgetId: widgetId
                }

            ).done(function (results) {

                if (results) {

                    // The 'widget' js selector is generated uniquely each time the widget begins to load.
                    // If someone is toggling widgets/layouts before widgets are done loading, this call is still going to return from the previous load that was interrupted
                    // At that point, the selector will have a new unique value, and there won't be an element with a data-js tag that correponds to the old call
                    // Making this not required essentially disregards what was returned from the old call (which is what we want)
                    $.js(jsSelector, { required: false }).html(results);
                }
            });
        }

        // Exported public API
        var exports = {
            initialize,
            initializeWidgetFrame,
            initializeWidget
        };

        return exports;
    }
);

